import { useEffect, useRef, useState } from "react";


const useHoverRef = <T extends HTMLElement>():[boolean,React.RefObject<T>] => {
    const [isHovered, setIsHovered] = useState(false);
    const ref = useRef<T>(null);
  
    const handleMouseEnter = () => {
      setIsHovered(true);
    };
  
    const handleMouseLeave = () => {
      setIsHovered(false);
    };
  
    useEffect(() => {
      const currentRef = ref.current;
  
      if (currentRef) {
        currentRef.addEventListener('mouseenter', handleMouseEnter);
        currentRef.addEventListener('mouseleave', handleMouseLeave);
  
        return () => {
          currentRef.removeEventListener('mouseenter', handleMouseEnter);
          currentRef.removeEventListener('mouseleave', handleMouseLeave);
        };
      }
    }, [ref]);
  
    return [isHovered,ref];

};

export default useHoverRef